module.exports = __webpack_public_path__ + "img/logo.52bfa1e5.png";